<p-panel header="Select Facility Address">
  <p-table
    #dt
    [value]="tableData"
    selectionMode="single"
    responsiveLayout="scroll"
    dataKey="providerAccountId"
    data-test-id="facility-select-table"
    [columns]="cols"
    [paginator]="true"
    [alwaysShowPaginator]="false"
    [rows]="10"
    [sortMode]="isExternal ? 'multiple' : 'single'"
    [multiSortMeta]="multiSortMeta"
    [globalFilterFields]="['providerName', 'providerAddress']"
    (onRowSelect)="selectProvider($event.data)"
    >
    @if (isExternal) {
      <ng-template pTemplate="caption">
        <p-input-group class="flex justify-start mb-4">
          <input
            pInputText
            class="filter-columns"
            type="text"
            placeholder="Search"
            data-test-id="table-filter-input"
            [(ngModel)]="searchInput"
            >
            <button
              pButton
              class="p-button-secondary"
              type="button"
              icon="pi pi-search"
              data-test-id="table-filter-button"
              (click)="tableFiltering()"
            ></button>
          </p-input-group>
        </ng-template>
      }
      <ng-template pTemplate="header">
        <tr>
          <th>Level of Care</th>
          <th>Servicing Facility Name</th>
          <th>Address</th>
          <th>Phone</th>
          <th>Fax</th>
          <th class="text-center">Fax Confirmed</th>
          <th class="text-center">In-Network for Member</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-facility let-rowIndex="rowIndex">
        <tr [pSelectableRow]="facility" [pSelectableRowIndex]="rowIndex">
          <td>{{ facility.facilityServiceType }}</td>
          <td>{{ facility.providerName }}</td>
          <td>
            {{ facility.physicalStreet }},
            {{ facility.physicalCity }}
            {{ facility.physicalState }}
            {{ facility.physicalZip | zipCode }}
          </td>
          <td>{{ facility.locationPhone | phoneNumber }}</td>
          <td>{{ facility.locationFax | phoneNumber }}</td>
          <td class="text-center">
            @if (facility.locationFaxConfirmed) {
              <i
                aria-hidden="true"
                class="pi pi-check"
              ></i>
            }
          </td>
          <td class="text-center">
            @if (!facility.outOfMembersNetwork) {
              <i
                aria-hidden="true"
                class="pi pi-check"
              ></i>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No records found</td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
